import React, { useEffect } from 'react'
import { Flex, Stack } from '@mantine/core'
import { SortableWidgetChildren } from '../SortableComponents'
import { ContainerWrapper } from '../ContainerWrapper'
import { useWidgetEditor } from '../state'
import { ContainerForm } from '../ContainerForm'
import cls from './common.module.css'
import { KpiTabsContainerOptions } from '../schemas'
import { useMetrics } from '../api'
import Tabs from '../../stories/Tabs/Tabs'
import { WidgetContextProvider } from '../providers'
import classes from './KpiTabsContainer.module.css'
import { Typography } from '../../common/typography'

export default function KpiTabsContainer({
  id,
  style,
  title,
  subheading,
  children,
}: {
  id: string
  style?: React.CSSProperties
  title?: string
  subheading?: React.ReactNode
  children?: React.ReactNode
}) {
  const editor = useWidgetEditor()
  const config = editor.useConfig(id)

  const metrics = useMetrics()
  const kpis = React.useMemo(() => {
    return (metrics.data || [])
      .filter((metric) => metric.is_kpi)
      .map((k) => ({
        value: k.key,
        label: k.name,
      }))
  }, [metrics.data])
  const [selectedKpi, setSelectedKpi] = React.useState<string>('')
  useEffect(() => {
    if (kpis.length > 0 && !selectedKpi) {
      setSelectedKpi(kpis[0].value)
    }
  }, [kpis])

  if (config && config.widget !== 'KpiTabsContainer')
    throw new Error('Invalid widget type, expected Container')

  const options =
    config?.options || KpiTabsContainerRegistry.getInitialOptions()

  return (
    <ContainerWrapper
      name="Container"
      id={id}
      onCancel={editor.endEditWidget}
      onSave={editor.save}
      style={style}
    >
      <WidgetContextProvider
        context={{
          metric: selectedKpi,
        }}
      >
        <Stack gap="sm">
          <div className={classes.head}>
            <Typography
              className={classes.title}
              level={3}
              fs="xl"
              fw={500}
              lh="125"
            >
              {title}
            </Typography>

            <Tabs items={kpis} value={selectedKpi} onChange={setSelectedKpi} />
          </div>
          {subheading}
          <Flex
            gap={8}
            direction={options.direction === 'horizontal' ? 'row' : 'column'}
            className={options.direction === 'horizontal' ? cls.flexFill : ''}
          >
            {children}
            <SortableWidgetChildren id={id} dir="horizontal" />
          </Flex>
        </Stack>
      </WidgetContextProvider>
    </ContainerWrapper>
  )
}

export const KpiTabsContainerRegistry = {
  component: KpiTabsContainer,
  formComponent: ContainerForm,
  mock: () => null,
  getInitialOptions: () => KpiTabsContainerOptions.parse({}),
}
